import axios from 'axios'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'
import devHelper from '../../util/devHelper'
import debugHelper from '../../util/debug'
import msgbus from '../../msgBus'


const state = {
  workType: '', // 工作类型 task/application
  flowTypes: {}, // 流程类型列表
  userFlows: [], // 用户流程列表
  userTasks: [], // 用户任务列表
  flowInfo: {}, // 指定流程详情
  flowFiles: [], // 流程文件列表
  flowProcess: [], // 流程过程信息

  userTasksStatus: 0, // 用户流程列表状态：0未初始化，200成功，其他失败
  userTasksMessage: '', // 用户流程列表信息

  userFlowTotalCount: 0, // 用户流程总数
  userTaskTotalCount: 0, // 用户任务总数

  userAwaitingFlowTotalCount: 0, // 用户审批中流程总数
  userAwaitingTaskTotalCount: 0, // 用户未审批任务总数

  flowListRecordCount: 0, // 流程已经加载的记录数
  taskListRecordCount: 0, // 任务已经加载的记录数

  // 我的申请页的流程状态过滤信息
  flowStateFilterSetInfo: [
    {
      state: 'awaiting_approval',
      name: '审批中',
      icon: 'assignment',
      color: 'green',
    },
  ],
  // 我的申请页的流程类型过滤信息
  flowTypeFilterSetInfo: [
    {
      defaultTitle: '全部',
      id: -1,
      name: '全部',
      type: '',
    }
  ],

  // 我的任务页的任务状态过滤信息
  taskStateFilterSetInfo: [
    {
      state: 'awaiting',
      name: '未处理',
      icon: 'assignment',
      color: 'green',
    },
  ],
  // 我的任务页的流程类型过滤信息
  taskFlowTypeFilterSetInfo: [
    {
      defaultTitle: '全部',
      id: -1,
      name: '全部',
      type: '',
    }
  ],

  // 焦点流程
  currentFlow: {
    flowID: null, // 焦点流程ID
    flowTid: null // 焦点流程对应的租户tid
  }
}

const getters = {
  getWorkType: state => {
    return state.workType
  },
  getFlowTypes: state => {
    return state.flowTypes
  },
  getUserFlows: state => {
    return state.userFlows
  },
  getUserTasks: state => {
    return state.userTasks
  },
  getUserTasksStatus: state => {
    return state.userTasksStatus
  },
  getUserTasksMessage: state => {
    return state.userTasksMessage
  },
  getFlowInfo: state => {
    return state.flowInfo
  },
  getFlowFiles: state => {
    return state.flowFiles
  },
  getFlowProcess: state => {
    return state.flowProcess
  },
  getUserFlowTotalCount: state => {
    return state.userFlowTotalCount
  },
  getUserTaskTotalCount: state => {
    return state.userTaskTotalCount
  },
  getUserAwaitingFlowTotalCount: state => {
    return state.userAwaitingFlowTotalCount
  },
  getUserAwaitingTaskTotalCount: state => {
    return state.userAwaitingTaskTotalCount
  },
  getFlowListRecordCount: state => {
    return state.flowListRecordCount
  },
  getTaskListRecordCount: state => {
    return state.taskListRecordCount
  },
  getFlowStateFilterSetInfo: state => {
    return state.flowStateFilterSetInfo
  },
  getFlowTypeFilterSetInfo: state => {
    return state.flowTypeFilterSetInfo
  },
  getTaskStateFilterSetInfo: state => {
    return state.taskStateFilterSetInfo
  },
  getTaskFlowTypeFilterSetInfo: state => {
    return state.taskFlowTypeFilterSetInfo
  },
  getCurrentFlow: state => {
    return state.currentFlow
  },
}


const actions = {
  // 获取租户的审批流程类型列表
  fetchFlowTypes: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/flow-types',
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setFlowTypes', { value: resp.data.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 获取当前用户提交的审批流程列表（用于首页查询 或 不分页查询）
  fetchUserFlows: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-flows',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setUserFlows', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 获取当前用户提交的审批流程列表（用于翻页追加查询）
  appendUserFlows: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-flows',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setAppendUserFlows', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 获取当前用户任务列表（审批任务）（用于首页查询 或 不分页查询）
  fetchUserTasks: ({ commit, state }, params) => {
    console.log('调试代码')

    return new Promise((resolve, reject) => {
      if (state.userTasksStatus !== 0 && state.userTasksStatus !== 200) {
        commit('setUserTasks', {
          value: {
            status: 0,
            message: ''
          }
        })
      }
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-tasks',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        },
        signal: params.signal,
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setUserTasks', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          const tips = tools.parseTips(err)
          if (err.message !== 'canceled') {
            commit('setUserTasks', {
              value: {
                status: 400,
                message: (tips || {}).text || err
              }
            })
          }
          reject()
          return
        })
    })
  },
  // 获取当前用户任务列表（审批任务）（用于翻页追加查询）
  appendUserTasks: ({ commit }, params) => {
    console.log('调试代码')

    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-tasks',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setAppendUserTasks', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 获取流程详情
  fetchFlowInfo: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/flows/' + params.flowID,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setFlowInfo', { value: resp.data.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

  // 获取流程文件信息
  fetchFlowFiles: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/flows/' + params.flowID + '/files',
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setFlowFiles', { value: resp.data.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

  // 获取流程过程信息
  fetchFlowProcess: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/flows/' + params.flowID + '/process',
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setFlowProcess', { value: resp.data.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

  // 请求工作流原文件
  requestFlowSourceFiles: ({ commit }, params) => {

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/download/request-workflow-source-files/' + params.flowID,
        data: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

  // 检查文件是否准备就绪
  checkPreparedDownloadFile: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/download/check-prepared-download-file/' + params.downloadID,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          resolve(resp.data)
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },


  // 获取用户审批中流程总数
  fetchUserAwaitingFlowsTotalCount: ({ commit }, params) => {
    if (msgbus.vm.isEDS16()) {
      let filter = {
        state: 'awaiting_approval', // 审批中
      }
      var data = {
        skip: 0,
        limit: 0,
        filter: JSON.stringify(filter)
      }
    } else {
      data = {
        state: 'awaiting_approval', // 审批中
        skip: 0,
        limit: 0,
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-flows',
        params: data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setUserAwaitingFlowTotalCount', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 获取用户未审批任务总数
  fetchUserAwaitingTasksTotalCount: ({ commit }, params) => {
    console.log('调试代码')
    if (msgbus.vm.isEDS16()) {
      let filter = {
        state: 'awaiting', // 未审批
        nodeType: 'approve', // 强制查询：审批任务
      }
      var data = {
        skip: 0,
        limit: 0,
        filter: JSON.stringify(filter)
      }
    } else {
      data = {
        state: 'awaiting', // 未审批
        type: 'approval', // 强制查询：审批任务
        skip: 0,
        limit: 0,
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/user-tasks',
        params: data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        },
        signal: params.signal,
      })
        .then(resp => {
          debugHelper.log(resp)
          commit('setUserAwaitingTaskTotalCount', { value: resp.data })
          resolve()
        })
        .catch(err => {
          if (params.prompt) {
            err.type = 'error'
            err.prefix = 'work:'
            tools.showTips(params.vm, err)
          }
          reject()
          return
        })
    })
  },

  // 待审批任务-同意
  taskApprove: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      if (msgbus.vm.isEDS16()) {
        var data = {
          remark: params.data,
        }
      } else {
        data = {
          note: params.data,
        }
      }
      axios({
        method: 'post',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/tasks/' + params.taskID + '/actions/approve',
        data: data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('modifyTask', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 待审批任务-拒绝
  taskReject: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {

      if (msgbus.vm.isEDS16()) {
        var data = {
          remark: params.data,
        }
      } else {
        data = {
          note: params.data,
        }
      }
      axios({
        method: 'post',
        url: URLS.EDS_TENANTS_URL + '/' + params.tid + '/tasks/' + params.taskID + '/actions/reject',
        data: data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('modifyTask', { value: resp.data })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'work:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
}

const mutations = {
  setWorkType: (state, payload) => {
    state.workType = payload.value
  },
  setFlowTypes: (state, payload) => {
    let flowTypes = payload.value
    let all = {
      defaultTitle: '全部',
      id: -1,
      name: '全部',
      type: '',
    }
    flowTypes.unshift(all)

    state.flowTypes = flowTypes.reduce((p, c) => {
      p[c.type] = c
      return p
    }, {})
  },
  setUserFlows: (state, payload) => {
    state.userFlowTotalCount = payload.value.total // 记录总数
    state.userFlows.splice(0, state.userFlows.length) // 清空数组
    if (payload.value.data) {
      payload.value.data.forEach(flow => {
        state.userFlows.push(flow)
      })
    }
  },
  setAppendUserFlows: (state, payload) => {
    state.userFlowTotalCount = payload.value.total // 记录总数
    payload.value.data.forEach(flow => {
      state.userFlows.push(flow)
    })
  },
  setUserTasks: (state, payload) => {
    if (payload.value.status === 0) {
      state.userTasksStatus = payload.value.status
      state.userTasksMessage = ''
    } else if (payload.value.status === 200) {
      state.userTasksStatus = payload.value.status
      state.userTasksMessage = ''
      state.userTaskTotalCount = payload.value.total // 记录总数
      state.userTasks.splice(0, state.userTasks.length) // 清空数组
      if (payload.value.data) {
        payload.value.data.forEach(task => {
          state.userTasks.push(task)
        })
      }
    } else {
      state.userTasksStatus = payload.value.status
      state.userTasksMessage = payload.value.message
      state.userTaskTotalCount = 0
      state.userTasks = []
    }
  },
  setAppendUserTasks: (state, payload) => {
    state.userTaskTotalCount = payload.value.total // 记录总数
    payload.value.data.forEach(task => {
      state.userTasks.push(task)
    })
  },
  setFlowInfo: (state, payload) => {
    state.flowInfo = payload.value
  },
  setFlowFiles: (state, payload) => {
    state.flowFiles = payload.value
  },
  setFlowProcess: (state, payload) => {
    state.flowProcess = payload.value
  },
  setUserAwaitingFlowTotalCount: (state, payload) => {
    state.userAwaitingFlowTotalCount = payload.value.total
  },
  setUserAwaitingTaskTotalCount: (state, payload) => {
    state.userAwaitingTaskTotalCount = payload.value.total
  },
  setFlowListRecordCount: (state, payload) => {
    state.flowListRecordCount = payload.value
  },
  setTaskListRecordCount: (state, payload) => {
    state.taskListRecordCount = payload.value
  },
  setFlowStateFilterSetInfo: (state, payload) => {
    state.flowStateFilterSetInfo = payload.value
  },
  setFlowTypeFilterSetInfo: (state, payload) => {
    state.flowTypeFilterSetInfo = payload.value
  },
  setTaskStateFilterSetInfo: (state, payload) => {
    state.taskStateFilterSetInfo = payload.value
  },
  setTaskFlowTypeFilterSetInfo: (state, payload) => {
    state.taskFlowTypeFilterSetInfo = payload.value
  },
  setCurrentFlow: (state, payload) => {
    state.currentFlow = payload.value
  },
  modifyTask: (state, payload) => {
    var tasksTmp = state.userTasks
    var taskInfo = payload.value.data
    tasksTmp.forEach(task => {
      if (task.id === taskInfo.id) {
        // 更新操作信息
        task.note = taskInfo.note
        task.processTime = taskInfo.processTime
        task.state = taskInfo.state
      }
    })
  },
  switchTenant: (state, payload) => {
    Object.assign(state, {
      flowTypes: {},
      userFlows: [],
      userTasks: [],
      flowInfo: {},

      userTasksStatus: 0,
      userTasksMessage: '',

      userFlowTotalCount: 0,
      userTaskTotalCount: 0,

      userAwaitingFlowTotalCount: 0,
      userAwaitingTaskTotalCount: 0,

      flowListRecordCount: 0,
      taskListRecordCount: 0,
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
